import { useEffect, useState } from 'react';
import _ from 'lodash';
import { API } from 'common/constants/api-urls';
import useFetch from 'use-http';
import axios from 'axios';

const useProjectConfiguration = project => {
  const {
    get,
    put,
    post,
    delete: deleteProject,
    response,
    loading,
    error
  } = useFetch(`${API.PM_PROJECTS_VIEW}/configuration`);
  const [loadingConfiguration, setLoadingConfiguration] = useState(false);

  const [configuration, setConfiguration] = useState(null);

  const getConfiguration = () => get(project.id);

  const upsertConfiguration = async payload => {
    const method = _.get(project, 'id', null) ? put : post;

    const updatedConfiguration = await method(_.get(project, 'id'), payload);
    if (response.ok) {
      setConfiguration(updatedConfiguration);
    } else {
      throw new Error(updatedConfiguration?.description);
    }

    return {
      upsertedProject: updatedConfiguration,
      isNew: !_.get(project, 'id', null)
    };
  };

  const deleteFromDB = async projectId => {
    await axios.delete(`${API.PDT_PROJECTS_CONFIG}/${projectId}?schema=pdt`);
  };

  useEffect(() => {
    const loadConfiguration = async () => {
      setLoadingConfiguration(true);
      try {
        const configuration = await getConfiguration();
        setConfiguration(response.ok ? configuration : {});
      } catch (exp) {}
      setLoadingConfiguration(false);
    };
    if (project.id) {
      loadConfiguration();
    }
  }, [project.id]);

  return {
    configuration,
    error,
    loading,
    getConfiguration,
    upsertConfiguration,
    deleteProject,
    loadingConfiguration,
    deleteFromDB
  };
};

export default useProjectConfiguration;
